import styled from 'styled-components';

export const SectionForm = styled.div`
  background-color: #f2f2f2;
  padding: 50px 0;

  position: relative;
  &:after {
    display: ${({ loading, isPlanEvent }) => {
      if (isPlanEvent) {
        return loading ? 'none' : 'block';
      }
      return 'none';
    }};
    content: '';
    position: absolute;
    top: 30rem;
    left: 0;
    width: 100%;
    height: ${({ isArabic }) => (isArabic ? '42rem' : '46rem')};
    background: #fff;

    @media (min-width: 302px) {
      height: ${({ isArabic }) => (isArabic ? '42rem' : '44rem')};
      top: ${({ isIphone }) => (isIphone ? '21rem' : '30rem')};
    }

    @media (min-width: 340px) {
      height: ${({ isArabic }) => (isArabic ? '40rem' : '44rem')};
      top: ${({ isIphone }) => (isIphone ? '21rem' : '30rem')};
    }
    @media (min-width: 368px) {
      top: ${({ isIphone }) => (isIphone ? '28rem' : '28rem')};
      height: ${({ isArabic }) => (isArabic ? '41rem' : '44rem')};
    }
    @media (min-width: 440px) {
      height: ${({ isArabic }) => (isArabic ? '40rem' : '42rem')};
    }
    @media (min-width: 486px) {
      height: ${({ isArabic }) => (isArabic ? '40rem' : '42rem')};
    }
    @media (min-width: 768px) {
      height: ${({ isArabic }) => (isArabic ? '36rem' : '43rem')};
    }
    @media (min-width: 992px) {
      top: 14rem;
      height: ${({ isArabic }) => (isArabic ? '36rem' : '37rem')};
    }
    @media (min-width: 1108px) {
      height: ${({ isArabic }) => (isArabic ? '29rem' : '37rem')};
    }
    @media (min-width: 1200px) {
      height: 38rem;
    }
  }

  &.contactus_form {
    @media (max-width: 767.98px) {
      padding-bottom: 100px;
    }
    .Form {
      button {
        position: absolute;
        right: ${({ dir }) => (dir === 'rtl' ? '' : '15px')};
        left: ${({ dir }) => (dir === 'rtl' ? '15px' : '')};
        bottom: -25px;
        @media (max-width: 767.98px) {
          position: absolute;
          right: 50%;
          bottom: inherit;
          transform: translateX(50%);
        }
      }
      .Form-fieldset {
        &:nth-child(5) {
          .Form-column {
            &:nth-child(2) {
              @media (max-width: 767.98px) {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  &.freezone_enquiryform {
    padding-bottom: 100px;
    .Form {
      .Form-fieldGroup {
        textarea {
          height: 150px;
        }
      }
      .Form-fieldset {
        &:nth-child(2) {
          display: flex;
          justify-content: center;
        }
      }
      button {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background-color: #ce445b;
        &:hover {
          background-color: #98293b;
        }
      }
    }
  }
  &.realestate_enquiryform {
    padding-bottom: 100px;
    .Form-fieldset {
      &:nth-child(2) {
        display: flex;
        justify-content: center;
      }
    }
    button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background-color: #1ba39c;
      &:hover {
        background-color: #1a746f;
      }
    }
    .checkbox-container {
      display: flex;
      div {
        flex: inherit !important;
      }
    }
  }
  &.planevent_form {
    padding-bottom: 100px;
    .Form-fieldset {
      &:nth-child(1) {
        .Form-column[data-columns='4'] {
          @media (max-width: 991.98px) {
            grid-column: span 12;
          }
          @media (max-width: 1199.98px) {
            .Form-fieldGroup {
              input,
              select {
                font-size: 14px;
              }
            }
          }
        }
      }
      &:nth-child(2) {
        .Form-column {
          .Form-fieldGroup {
            &:nth-child(1) {
              opacity: 0;
            }
            &:nth-child(2) {
              padding-top: 150px;
              @media (max-width: 767.98px) {
                padding-top: 90px;
              }
              label[for='additionalServices'] {
                position: relative;
                z-index: 1;
                font-size: 30px;
                font-family: ${({ dir }) =>
                  dir === 'rtl' ? 'GEAwtarDWTCMedium,serif' : 'LibreBaskervilleRegular '};
                font-weight: 400;
                line-height: 50px;
                padding: 20px 0;
                position: relative;
                text-align: center;
                color: #4a4a4a;
                width: 100%;
                @media (max-width: 1199.98px) {
                  font-size: 26px;
                  line-height: 30px;
                }
                @media (max-width: 767.98px) {
                  font-size: 20px;
                  line-height: 30px;
                  margin-top: 1rem;
                  margin-bottom: 0px;
                }
              }
              .checkbox-container {
                z-index: 1 !important;
                position: relative !important;
                @media (min-width: 1200px) {
                  padding: 0 50px;
                }
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                div {
                  @media (min-width: 1200px) {
                    width: 259px;
                    margin: 10px;
                    text-align: center;
                  }
                  flex: inherit;
                  position: relative;
                  font-size: 20px;
                  line-height: 30px;
                  font-family: ${({ dir }) =>
                    dir === 'rtl' ? 'GESSTwoDWTCLight,serif' : 'LibreBaskervilleRegular '};
                  letter-spacing: normal;
                  margin: 0.5rem;
                  padding-left: ${({ dir }) => (dir === 'rtl' ? '' : '0rem')};
                  padding-right: ${({ dir }) => (dir === 'rtl' ? '0rem' : '')};
                  @media (max-width: 575.98px) {
                    width: 100%;
                    margin: 10px 1.5rem;
                    font-size: 12px;
                  }

                  input {
                    cursor: pointer;
                    opacity: 0;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    border: none;
                  }
                  input:checked + label {
                    border: 1px solid #1b7bdd;
                  }
                  label {
                    &:before {
                      display: none;
                    }
                    display: block;
                    padding: 30px;
                    border: 1px solid #ebebeb;
                    position: relative;
                    font-size: 20px;
                    line-height: 30px;
                    font-family: ${({ dir }) =>
                      dir === 'rtl' ? 'GESSTwoDWTCLight,serif' : 'LibreBaskervilleRegular '};
                    letter-spacing: normal;
                    @media (max-width: 575.98px) {
                      padding: 5px;
                      text-align: center;
                      border-radius: 50px;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      &:nth-child(3) {
        margin-top: 3rem;
      }
    }
    .title_sec {
      margin-bottom: 0rem;
      color: #4a4a4a;
      text-align: center;
      font-family: ${({ dir }) =>
        dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular !important'};
      font-size: 12px;
      letter-spacing: 1.29px;
      line-height: 16px;
      color: #898989;
    }
    .Form-page {
      margin-bottom: 0px;
    }
    .Form-fieldset {
      &:nth-child(4) {
        p {
          text-align: center !important;
          display: flex;
          flex-direction: column;
          @media (min-width: 400px) {
            flex-direction: row;
          }
        }
      }
    }
    button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    .planrange_wrapper {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
  &.newsletter_form {
    padding-bottom: 100px;
    margin-bottom: -50px;
    .Form-fieldset {
      &:nth-child(2) {
        display: flex;
        justify-content: center;
      }
    }
    button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .Form {
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      background: transparent;
      background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
      background-repeat: no-repeat;
      background-position-x: ${({ dir }) => (dir === 'rtl' ? '0%' : '100%')};
      background-position-y: 15px;
      border: 1px solid #dfdfdf;
      border-radius: 2px;
      margin-right: 2rem;
      padding: 1rem;
      padding-right: 2rem;
    }
  }
`;

export const SectionCaption = styled.h2`
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1.5rem;
  color: #4a4a4a;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : '')};
  @media (max-width: 1199.98px) {
    font-size: 18px;
  }
  @media (max-width: 767.98px) {
    font-size: 16px;
  }
`;

export const EnquiryFormSection = styled.div`
  background-color: #f2f2f2;
  padding: 50px 0 0;
`;

export const EnquiryFormHeading = styled.div`
  padding-bottom: 2rem;

  .mt-4 {
    margin-top: 1.5rem;
  }

  &.thank-you__container {
    padding: 0;
    transform: translateY(2.5rem);
  }

  .thank-you__msg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

export const FormGroup = styled.div`
  .form_control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    min-width: unset;
  }

  select.form_control {
    border-radius: 0;
    text-transform: uppercase;
    padding: 18px 20px;
    font-size: 10px;
    border: 0;
    letter-spacing: 1.82px;
    background-color: #fff;
    color: #000;
    height: calc(3.063rem + 2px) !important;
  }

  input.form_control {
    min-width: 245px;
    border-radius: 0;
    text-transform: uppercase;
    padding: 18px 20px;
    font-size: 10px;
    border: 0;
    letter-spacing: 1.82px;
    background-color: #fff;
    color: #000;
  }

  .LV_invalid_field {
    &:active {
      border: 1px solid #dc3545 !important;
    }
  }

  input[type='text']:hover {
    border-color: transparent;
  }

  input[type='text']:focus {
    box-shadow: none;
  }
`;

export const FormRow = styled.div`
  margin-top: 1rem !important;

  label {
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 1.5px;
    display: inline-block;
    margin-bottom: 0.5rem;
  }
`;

export const RadioButton = styled.div`
  min-height: 1.5rem;
  padding-left: 0.5rem;
  .custom-control-input {
    height: 13px;
  }
`;

export const RadioButtonHeading = styled.div`
  display: flex;
`;
